import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';
import dayjs from 'dayjs';
import {PDFDocument} from 'pdf-lib';
import { saveAs } from 'file-saver';

function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
}

function writeVariables(pages, xvalue, yvalue, variables) {		
	pages.drawText(variables, {
			  x: xvalue,
			  y: yvalue,
			  size:11
	})
}

function createAgreement(PDFVars,COMP,Terms,APR){			
	var existingPdfBytes = '';	
	fetch(process.env.REACT_APP_API_ENV+"api/getagreementpdf.php?user="+PDFVars[40])	
	.then(res => res.json()) 	
	.then(
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
			const thirdPage = pages[2]
			const fourPage = pages[3]
			const sixPage = pages[5]
			
						
			
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()
			if(PDFVars[17] !== "3") {
				writeVariables(firstPage, 110, height / 2 + 313, COMP[0])//Lender
				writeVariables(firstPage, 105, height / 2 + 299, COMP[5])//email
				writeVariables(firstPage, 350, height / 2 + 195, '$'+PDFVars[5])//amount borrowed
				writeVariables(firstPage, 350, height / 2 + 175, Terms)//Terms of Agreement in days
				writeVariables(firstPage, 350, height / 2 + 155, '$'+PDFVars[6])//total cost of borrowing
				writeVariables(firstPage, 350, height / 2 + 133, '$'+PDFVars[4])//maximum allowed cost per 100
				writeVariables(firstPage, 350, height / 2 + 113, '$'+PDFVars[4])//cost per 100 borrowed
				writeVariables(firstPage, 350, height / 2 + 93, APR+'%')//Annual Percentage rate
				writeVariables(firstPage, 350, height / 2 + 65, PDFVars[22])//Third loan?
				writeVariables(firstPage, 350, height / 2 + 28, PDFVars[23]+'   '+PDFVars[26])
				writeVariables(firstPage, 350, height / 2 - 2, PDFVars[24]+'   '+PDFVars[27])
				writeVariables(firstPage, 350, height / 2 - 35, PDFVars[25]+'   '+PDFVars[28])
				writeVariables(firstPage, 350, height / 2 - 60, PDFVars[19])//default interest rate
				writeVariables(firstPage, 350, height / 2 - 80, PDFVars[16])//borrower signature
				writeVariables(firstPage, 370, height / 2 - 142, '$'+PDFVars[20])
				writeVariables(firstPage, 150, height / 2 - 155, '$'+PDFVars[20]/2)			
				writeVariables(firstPage, 310, height / 2 - 215, PDFVars[29])
				writeVariables(firstPage, 380, height / 2 - 215, PDFVars[30])
				writeVariables(firstPage, 450, height / 2 - 215, PDFVars[31])				
				writeVariables(thirdPage, 108, height / 2 - 8, PDFVars[18])
				writeVariables(thirdPage, 320, height / 2 - 8, PDFVars[19])				
				writeVariables(sixPage, 195, height / 2 + 110, COMP[6])
				writeVariables(sixPage, 190, height / 2 + 85, COMP[0])
				writeVariables(sixPage, 415, height / 2 + 85, PDFVars[11])
				writeVariables(sixPage, 190, height / 2 + 60, PDFVars[16])
				writeVariables(sixPage, 415, height / 2 + 60, PDFVars[10])
				writeVariables(sixPage, 200, height / 2 + 30, PDFVars[16])
				writeVariables(sixPage, 415, height / 2 + 30, PDFVars[32])
				writeVariables(sixPage, 190, height / 2 + 2, PDFVars[33]+', '+PDFVars[34]+', '+PDFVars[35]+', '+PDFVars[36])
			} else if(PDFVars[17] === "3" ) {
				writeVariables(firstPage, 110, height / 2 + 313, COMP[0])//Lender
				writeVariables(firstPage, 105, height / 2 + 299, COMP[5])//email
				writeVariables(firstPage, 350, height / 2 + 205, '$'+PDFVars[5])//amount borrowed
				writeVariables(firstPage, 350, height / 2 + 180, Terms)//Terms of Agreement in days
				writeVariables(firstPage, 350, height / 2 + 160, '$'+PDFVars[6])//total cost of borrowing
				writeVariables(firstPage, 350, height / 2 + 140, '$'+PDFVars[4])//maximum allowed cost per 100
				writeVariables(firstPage, 350, height / 2 + 115, '$'+PDFVars[4])//cost per 100 borrowed
				writeVariables(firstPage, 350, height / 2 + 95, APR+'%')//Annual Percentage rate				
				writeVariables(firstPage, 350, height / 2 + 70, PDFVars[23]+'   '+PDFVars[26])
				writeVariables(firstPage, 350, height / 2 + 40, PDFVars[24]+'   '+PDFVars[27])
				writeVariables(firstPage, 350, height / 2 + 0, PDFVars[25]+'   '+PDFVars[28])
				writeVariables(firstPage, 350, height / 2 - 25, PDFVars[19])//default interest
				writeVariables(firstPage, 350, height / 2 - 45, PDFVars[16])//borrower signature
				writeVariables(firstPage, 415, height / 2 - 120, PDFVars[16])//acknowledge
				writeVariables(thirdPage, 508, height / 2 + 240, PDFVars[18])
				writeVariables(thirdPage, 390, height / 2 + 227, PDFVars[19])				
				writeVariables(fourPage, 260, height / 2 - 70, PDFVars[37])
				writeVariables(fourPage, 508, height / 2 - 70, PDFVars[38])
				writeVariables(fourPage, 336, height / 2 - 102, APR+'%')
				writeVariables(fourPage, 277, height / 2 - 115, PDFVars[18])
				writeVariables(fourPage, 198, height / 2 - 148, PDFVars[19])
				
			}
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, 'Payday Loan Agreement.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}
//Pre-Authorized
function createPADAgreement(PDFVars,COMP,Terms,APR){			
	var existingPdfBytes = '';			
	fetch(process.env.REACT_APP_API_ENV+"api/getpadpdf.php")	
	.then(res => res.json()) 	
	.then(	
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
								
			
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()					
			writeVariables(firstPage, width/2 - 20, height / 2 + 299, COMP[0])//Lender
			writeVariables(firstPage, 130, height / 2 + 260, COMP[0])//Lender
			writeVariables(firstPage, 70, height / 2 + 185, COMP[0])//Lender
			writeVariables(firstPage, 196, height / 2 + 70, COMP[0])//Lender
			writeVariables(firstPage, 100, height / 2 + 44, PDFVars[16])//Client name
			writeVariables(firstPage, 110, height / 2 + 20, PDFVars[33])//Client Address
			writeVariables(firstPage, 100, height / 2 - 2,PDFVars[34])//city
			writeVariables(firstPage, 115, height / 2 - 25, PDFVars[35])//Province
			writeVariables(firstPage, 125, height / 2 - 48, PDFVars[36])//Post Code
			writeVariables(firstPage, 140, height / 2 - 72, PDFVars[32])//Phone
			writeVariables(firstPage, 145, height / 2 - 95, PDFVars[43])//Account Number
			writeVariables(firstPage, 160, height / 2 - 118, PDFVars[42])//FIN
			writeVariables(firstPage, 140, height / 2 - 142, PDFVars[41])//Transit
			writeVariables(firstPage, 110, height / 2 - 163, '$'+PDFVars[5])//approved amount
			writeVariables(firstPage, 165, height / 2 - 210, PDFVars[16])//borrower signature
			writeVariables(firstPage, 100, height / 2 - 233, PDFVars[10])//sign date			
			writeVariables(firstPage, 395, height / 2 - 267, COMP[0])//Lender		
			
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, 'Pre-Authorized Debit Agreement_'+PDFVars[16]+'.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}


//Annual Loan Activity Report
function createAnnualReport(PDFVars){			
	var existingPdfBytes = '';			
	fetch(process.env.REACT_APP_API_ENV+"api/getloanreport.php")	
	.then(res => res.json()) 	
	.then(	
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
			const secondPage = pages[1]					
			const thirdpage = pages[2]	
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()					
			writeVariables(firstPage, 150, height / 2 + 20, PDFVars[0])//legal name
			writeVariables(firstPage, 150, height / 2 - 10, PDFVars[1])//license number
			writeVariables(firstPage, 310, height / 2 - 18, "x")//license number
			writeVariables(firstPage, 110, height / 2 - 55, PDFVars[2])//street number
			writeVariables(firstPage, 350, height / 2 - 50, PDFVars[3])//street name
			writeVariables(firstPage, 110, height / 2 - 80, PDFVars[4])//city
			writeVariables(firstPage, 350, height / 2 - 80, PDFVars[5])//Province
			writeVariables(firstPage, 510, height / 2 - 90, PDFVars[6])//postcode
			writeVariables(firstPage, 20, height / 2 - 120, PDFVars[7])//phone
			writeVariables(firstPage, 350, height / 2 - 120, PDFVars[8])//email
			writeVariables(firstPage, 20, height / 2 - 185, PDFVars[9])//Full name
			writeVariables(firstPage, 400, height / 2 - 185, PDFVars[10])//position
			writeVariables(firstPage, 20, height / 2 - 220, PDFVars[9])//Signature
			writeVariables(firstPage, 400, height / 2 - 220, PDFVars[40])//date
			//second page
			writeVariables(secondPage, 540, height / 2 + 335, PDFVars[41])//Year
			writeVariables(secondPage, 545, height / 2 + 275, PDFVars[11])//total loans
			writeVariables(secondPage, 545, height / 2 + 240, PDFVars[12])//up to 500
			writeVariables(secondPage, 545, height / 2 + 225, PDFVars[13])//up to 1000
			writeVariables(secondPage, 545, height / 2 + 205, PDFVars[14])//over 1000
			writeVariables(secondPage, 545, height / 2 + 185, "0")//over 1500
			writeVariables(secondPage, 545, height / 2 + 169, PDFVars[15])//Average Terms
			writeVariables(secondPage, 545, height / 2 + 125, PDFVars[16])//1~7 Days
			writeVariables(secondPage, 545, height / 2 + 105, PDFVars[17])//8~14 Days
			writeVariables(secondPage, 545, height / 2 + 87, PDFVars[18])//15~21 Days
			writeVariables(secondPage, 545, height / 2 + 67, PDFVars[19])//22~30 Days
			writeVariables(secondPage, 545, height / 2 + 50, PDFVars[20])//31~62 Days
			writeVariables(secondPage, 545, height / 2 + 30, PDFVars[21])//over 62 Days
			writeVariables(secondPage, 535, height / 2 + 7, PDFVars[22])//Total dollar value
			writeVariables(secondPage, 535, height / 2 - 15, PDFVars[23])//Total Dollar Cost
			//4.Borrowing Patterns
			writeVariables(secondPage, 545, height / 2 - 75, "0")//7. Same Calendar Day Loan
			writeVariables(secondPage, 545, height / 2 - 100, PDFVars[24])//8. Applicant
			writeVariables(secondPage, 545, height / 2 - 140, PDFVars[25])//1 Loan
			writeVariables(secondPage, 545, height / 2 - 155, PDFVars[26])//2~5 Loans
			writeVariables(secondPage, 545, height / 2 - 175, PDFVars[27])//6~10 Loans
			writeVariables(secondPage, 545, height / 2 - 192, PDFVars[28])//11~15 Loans
			writeVariables(secondPage, 545, height / 2 - 210, PDFVars[29])//16 more Loans
			
			writeVariables(secondPage, 545, height / 2 - 280, PDFVars[30])//10.Default Loans
			writeVariables(secondPage, 535, height / 2 - 315, PDFVars[31])//Total Dollar Cost
			writeVariables(secondPage, 545, height / 2 - 330, "0")//Total Dollar Cost
			writeVariables(secondPage, 545, height / 2 - 350, "0")//Total Dollar Cost
			//third page
			writeVariables(thirdpage, 555, height / 2 + 338, "x")
			writeVariables(thirdpage, 555, height / 2 + 210, "x")
			writeVariables(thirdpage, 555, height / 2 + 100, "x")
			writeVariables(thirdpage, 485, height / 2 + 25, "x")
			writeVariables(thirdpage, 555, height / 2 - 67, "x")
			
			
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, PDFVars[41]+'_Annual_Loan_Activity_Report.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}

//receipt of payment
function createPayment(PDFVars,COMP,Terms,APR){			
	var existingPdfBytes = '';			
	fetch(process.env.REACT_APP_API_ENV+"api/getpaymentpdf.php")	
	.then(res => res.json()) 	
	.then(	
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
								
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()	
			writeVariables(firstPage, 180, height / 2 + 237, PDFVars[16])//Client name
			writeVariables(firstPage, 215, height / 2 + 208, PDFVars[39])//AccountID
			writeVariables(firstPage, 155, height / 2 + 182, '$'+PDFVars[5])//Approved amount
			writeVariables(firstPage, 200, height / 2 + 152, PDFVars[11])//Agreement Date
			writeVariables(firstPage, 155, height / 2 + 98, '$'+PDFVars[7])//Paid Amount
			writeVariables(firstPage, 140, height / 2 + 70, PDFVars[13])//Paid Date
			writeVariables(firstPage, 285, height / 2 + 42, '$'+PDFVars[15])//New amount
			writeVariables(firstPage, 210, height / 2 - 42, COMP[0])//Lender		
			writeVariables(firstPage, 140, height / 2 - 69, PDFVars[13])//Paid Date
			
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, 'Receipt of Payment_'+PDFVars[16]+'.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}

//cancellation notice
function createCANNotice(PDFVars,COMP,Terms,APR){			
	var existingPdfBytes = '';			
	fetch(process.env.REACT_APP_API_ENV+"api/getcancellationotice.php")	
	.then(res => res.json()) 	
	.then(	
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
								
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()	
			writeVariables(firstPage, 420, height / 2 + 255,  COMP[0])//company name
			
			writeVariables(firstPage, 90, height / 2 + 81, PDFVars[16])//Client Name
			writeVariables(firstPage, 325, height / 2 + 81,  COMP[0])//company name			
			writeVariables(firstPage, 135, height / 2 - 3, PDFVars[10])//Loan Date			
			writeVariables(firstPage, 350, height / 2 - 3, '$'+PDFVars[3])//applied amount				
			writeVariables(firstPage, 135, height / 2 - 58, PDFVars[16])//Borrower
			writeVariables(firstPage, 350, height / 2 - 58, PDFVars[11])//Agreement Date
			
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, 'Loan Cancellation Notice_'+PDFVars[16]+'.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}
//cancellation receipt
function createCANReceipt(PDFVars,COMP,Terms,APR){			
	var existingPdfBytes = '';			
	fetch(process.env.REACT_APP_API_ENV+"api/getcancellationreceipt.php")	
	.then(res => res.json()) 	
	.then(	
		async (result) => {		
			var obj = JSON.parse(result);
			var binaryData = base64ToArrayBuffer(obj.data);
			existingPdfBytes = binaryData;
			
			const pdfDoc = await PDFDocument.load(existingPdfBytes);
			
			// Get the first page of the document
			const pages = pdfDoc.getPages()
			const firstPage = pages[0]
								
			// Get the width and height of the first page
			const { width, height } = firstPage.getSize()	
			writeVariables(firstPage, 73,  height / 2 + 220,  COMP[0])//company name			
			writeVariables(firstPage, 325, height / 2 + 205, PDFVars[16])//Client Name					
			writeVariables(firstPage, 135, height / 2 + 150, PDFVars[10])//Loan Date			
			writeVariables(firstPage, 150, height / 2 + 95, '$'+PDFVars[3])//applied amount							
			writeVariables(firstPage, 216, height / 2 - 16,  COMP[0])//company name	
			writeVariables(firstPage, 140, height / 2 - 45, PDFVars[11])//Date
			
			const pdfBytes = await pdfDoc.save()
			var blob = new Blob([pdfBytes])			
			saveAs(blob, 'Loan Cancellation Receipt_'+PDFVars[16]+'.pdf')			
		},

		(error) => {
			alert('Error happens');
		}
	)
}


class PaydayAgreement extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {downloads:'', GReports:'',accid:'',profileinfo:[],AID:'',APR:'',terms:'',CompName:'',Comps:'',
			user:localStorage.getItem('tokens')};				
	}

	componentDidMount() {		
		const para={LID:this.state.user}				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})	
				this.setState({Comps:result.data})
			})	
	}
	
	handleChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  		
	}
	handleReportChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value}) 		
		this.setState({downloads:''})
		const userObject = {		
				AID: event.target.value,
				LID:this.state.user,
				RID:this.state.GReports
			 }
		if(this.state.GReports != "6" && this.state.GReports !="") {
			axios.post(process.env.REACT_APP_API_ENV+'api/paydayreportinfo.php',userObject)
				.then(result => {					
					this.setState({profileinfo:result.data})
					this.setState({terms:dayjs(result.data[12]).diff(dayjs(result.data[11]).format('MM/DD/YYYY'),'d')})	
					this.setState({APR: (100*result.data[6]/(result.data[5]*(dayjs(result.data[12]).diff(dayjs(result.data[11]).format('MM/DD/YYYY'),'d'))/365)).toFixed(0)})
				})	
		} else if(this.state.GReports == "6") {
			axios.post(process.env.REACT_APP_API_ENV+'api/paydayreportinfo.php',userObject)
				.then(result => {					
					this.setState({profileinfo:result.data})					
				})				
		}
	}
		
	render() {	
		return(
			<div >
				<CommonHeader titles="Payday Loan Agreement"/>					
				<h3><b>Please Select Report {this.state.Comps+' and term='+this.state.terms.toString()+' and APR='+this.state.APR}</b></h3>
				<select name="GReports" style={{width: '150px',border:'1px solid #4195fc'}} value={this.state.GReports} onChange={this.handleChange}>
					<option value="">--select--</option>						
					<option value="1">PAD Loan Agreement</option>
					<option value="2">Pre-Authorized Debit Agreement</option>
					<option value="3">Receipt of Paymnet</option>
					<option value="4">Cancellation Notice</option>
					<option value="5">Cancellation Reciept</option>
					<option value="6">Ontario Annual Loan Activity Report</option>
				</select><br/>
				{(()=>{if(this.state.GReports !== "" && this.state.GReports != "6") {return (<div>
					<h3><b>Please Enter AccountID</b></h3>
					<input type="text" name="accid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.accid} onChange={this.handleReportChange}/>
					{(()=>{if(this.state.accid !== "") {return (<div>
						<h3 style={{textAlign:'center'}}><b>Payday Loan Information</b></h3><br/><br/><br/>
						<label style={{width: '300px',display:'inline-block',textAlign:'left'}}><b>Approved Loan Date:</b></label>						
						<label style={{width: '300px',display:'inline-block',textAlign:'left',color:'blue'}}>{this.state.profileinfo[11]}</label><br/><br/>				
						<label style={{width: '300px',display:'inline-block',textAlign:'left'}}><b>Approved Loan Amount:</b></label>
						<label style={{width: '300px',display:'inline-block',textAlign:'left',color:'blue'}}>{this.state.profileinfo[5]}</label><br/><br/>
						<label style={{width: '300px',display:'inline-block',textAlign:'left'}}><b>Borrower:</b></label>
						<label style={{width: '300px',display:'inline-block',textAlign:'left',color:'blue'}}>{this.state.profileinfo[16]}</label><br/><br/>
						<label style={{width: '300px',display:'inline-block',textAlign:'left'}}><b>Paid Amount:</b></label>
						<label style={{width: '300px',display:'inline-block',textAlign:'left',color:'blue'}}>{this.state.profileinfo[7]}</label><br/><br/>
						<label style={{width: '300px',display:'inline-block',textAlign:'left'}}><b>Paid Date:</b></label>
						<label style={{width: '300px',display:'inline-block',textAlign:'left',color:'blue'}}>{this.state.profileinfo[13]}</label><br/><br/>
						<h3 style={{textAlign:'center'}}>Download</h3>
						<select name="downloads" style={{width: '150px',border:'1px solid #4195fc'}} value={this.state.downloads} onChange={this.handleChange}>
							<option value="">--select--</option>						
							<option value="1">Download</option>															
						</select><br/><br/><br/>
					</div>)}})()}
				</div>)} else if(this.state.GReports == "6") {return (<div>
					<h3><b>Please Enter Year</b></h3>
					<input type="text" name="accid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.accid} onChange={this.handleReportChange}/>				
					{(()=>{if(this.state.accid !== "") {return (<div>
						<h3 style={{textAlign:'center'}}>Download</h3>
						<select name="downloads" style={{width: '150px',border:'1px solid #4195fc'}} value={this.state.downloads} onChange={this.handleChange}>
							<option value="">--select--</option>						
							<option value="1">Download</option>															
						</select><br/><br/><br/>
					</div>)}})()}
				</div>)}})()}
				{(()=>{if(this.state.GReports == "1" && this.state.downloads === "1" && this.state.profileinfo.length !== 0 && this.state.profileinfo[8] !== "1" && this.state.profileinfo[8] !== "5") {return (<div>
						<h3>Downloading Payday Loan Agreement</h3><br/><br/><br/>						
						{createAgreement(this.state.profileinfo,this.state.Comps, this.state.terms.toString(),this.state.APR)}						
				</div>)} else if(this.state.GReports == "2" && this.state.downloads === "1" && this.state.profileinfo.length !== 0 && this.state.profileinfo[8] !== "1" && this.state.profileinfo[8] !== "5") {return (<div>
						<h3>Downloading Pre-Authorized Debit Agreement</h3><br/><br/><br/>						
						{createPADAgreement(this.state.profileinfo,this.state.Comps, this.state.terms.toString(),this.state.APR)}						
				</div>)} else if(this.state.GReports == "3" && this.state.downloads === "1" && this.state.profileinfo.length !== 0 && this.state.profileinfo[8] !== "1" && this.state.profileinfo[8] !== "5") {return (<div>
						{(()=>{if(this.state.profileinfo[8] !== "2") {return (<div>
							<h3>Sorry, this application has not been paid yet. Please inform the applicant to pay us first</h3><br/><br/><br/>						
						</div>)} else {return (<div>
							<h3>Downloading Receipt of Payment</h3><br/><br/><br/>						
							{createPayment(this.state.profileinfo,this.state.Comps, this.state.terms.toString(),this.state.APR)}						
						</div>)}})()}				
				</div>)} else if(this.state.GReports == "4" && this.state.downloads === "1" && this.state.profileinfo.length !== 0 && this.state.profileinfo[8] !== "1" && this.state.profileinfo[8] !== "5") {return (<div>
						{(()=>{if(this.state.profileinfo[8] !== "55") {return (<div>
							<h3>Sorry, this loan application has not been cancelled.</h3><br/><br/><br/>						
						</div>)} else {return (<div>
							<h3>Downloading Cancellation Notice</h3><br/><br/><br/>						
							{createCANNotice(this.state.profileinfo,this.state.Comps, this.state.terms.toString(),this.state.APR)}						
						</div>)}})()}
				</div>)} else if(this.state.GReports == "5" && this.state.downloads === "1" && this.state.profileinfo.length !== 0 && this.state.profileinfo[8] !== "1" && this.state.profileinfo[8] !== "5") {return (<div>
						{(()=>{if(this.state.profileinfo[8] !== "13") {return (<div>
							<h3>Sorry, this loan application has not been cancelled.</h3><br/><br/><br/>						
						</div>)} else {return (<div>
							<h3>Downloading Cancellation Receipt</h3><br/><br/><br/>						
							{createCANReceipt(this.state.profileinfo,this.state.Comps, this.state.terms.toString(),this.state.APR)}						
						</div>)}})()}						
				</div>)} else if(this.state.GReports == "6" && this.state.downloads === "1") {return (<div>
						<h3>Downloading Annual Loan Activity Report</h3><br/><br/><br/>						
						{createAnnualReport(this.state.profileinfo)}						
				</div>)}})()}				
			</div>
		)
	}
}

export default PaydayAgreement